import { render, staticRenderFns } from "./video-report.vue?vue&type=template&id=2b171c32"
import script from "./video-report.vue?vue&type=script&lang=js"
export * from "./video-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports